import React from 'react';
import { Text, View } from '../../Components/Themed';

type FlashMarketHelpProps = {

}
const FlashMarketHelp = ({ }:FlashMarketHelpProps) => {

    return (
        <View transparent>
            <View transparent style={{ padding:10 }}>
                <Text theme='h1'>Flash Markets Explained</Text>
            </View>
            <View transparent>
                <View transparent type='row' style={{ padding:10 }}>
                    <Text theme='h1' size={20}>{'\u2022'}</Text>
                    <View transparent style={{ flex:1, marginLeft:10 }}>
                        <Text theme='h2'>Markets are Parimutuel</Text>
                        <Text theme='description' style={{ marginTop:3 }}>Odds shift dynamically as orders are placed.</Text>
                    </View>
                </View>
                <View transparent type='row' style={{ padding:10 }}>
                    <Text theme='h1' size={20}>{'\u2022'}</Text>
                    <View transparent style={{ flex:1, marginLeft:10 }}>
                        <Text theme='h2'>Minimum Pool Size</Text>
                        <Text theme='description' style={{ marginTop:3 }}>A set amount must be reached for the market to proceed.  If not reached, all orders are fully refunded.</Text>
                    </View>
                </View>
                <View transparent type='row' style={{ padding:10 }}>
                    <Text theme='h1' size={20}>{'\u2022'}</Text>
                    <View transparent style={{ flex:1, marginLeft:10 }}>
                        <Text theme='h2'>No-Action Winning Option</Text>
                        <Text theme='description' style={{ marginTop:3 }}>If an option with no orders wins, all orders are returned to users.</Text>
                    </View>
                </View>
            </View>
        </View>
    )
}

export default FlashMarketHelp